import { defineMetrics } from "../types.js"

export const watchlistsMetrics = defineMetrics([
  {
    id: "total_standards_watchlist",
    name: "Total Standards in Watchlist",
    description: "Total Standards being monitored.",
    logic: "Count Standard records within Watchlists.",
    source: "sum of $size(standardWatchlist.standards) — array sizes, not document count",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: false,
    caveat:
      "A sum of array lengths across the per-user watchlist documents, not a count of documents. Counting documents would report how many users have a watchlist at all, which is a different and much smaller number.",
    xlsxRow: 71,
  },
  {
    id: "total_legislations_watchlist",
    name: "Total Legislations in Watchlist",
    description: "Total Legislations being monitored.",
    logic: "Count Legislation records within Watchlists.",
    source: "legislationUser(inWatchlist = true) — not an array on standardWatchlist",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: false,
    xlsxRow: 72,
  },
  {
    id: "total_guidance_docs_watchlist",
    name: "Total Guidance Documents in Watchlist",
    description: "Total Guidance documents being monitored.",
    logic: "Count Guidance records within Watchlists.",
    source: "sum of $size(standardWatchlist.guidances)",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: false,
    xlsxRow: 73,
  },
  {
    id: "total_custom_watchlists",
    name: "Total Custom Watchlists",
    description: "Number of custom Watchlists created by users.",
    logic: "Count user-created Watchlists.",
    source: "standardRules + legislationRule — custom watchlists are rule-based",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: false,
    xlsxRow: 74,
  },
  {
    id: "watchlist_additions",
    name: "Watchlist Additions",
    description: "Number of items added to Watchlists.",
    logic: "Count additions during the reporting period. Requires an event log of additions over time",
    source: "auditTrail(module=Standard|Guidance|LegislationWatchList, action=Add … To Watchlist)",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stat-tile"],
    coveredByV1: false,
    caveat:
      "Item-level additions only, mirroring Watchlist Removals so the two net out as the dictionary intends. Creating or deleting a whole custom watchlist is excluded: counting it here would make one new watchlist read as one added item.",
    xlsxRow: 75,
  },
  {
    id: "total_assessments",
    name: "Total Assessments",
    description: "Total number of Assessments.",
    logic: "Count Assessment records.",
    source: "legislationAssessment.countDocuments()",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: false,
    xlsxRow: 77,
  },
  {
    id: "business_assessments",
    name: "Business Assessments",
    description: "Total Business Assessments.",
    logic: "Count Business Assessment records.",
    source: "legislationAssessment(type = Business) — the enum is capitalised",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["pie", "stacked-bar"],
    coveredByV1: false,
    xlsxRow: 78,
  },
  {
    id: "corporate_assessments",
    name: "Corporate Assessments",
    description: "Total Corporate Assessments.",
    logic: "Count Corporate Assessment records.",
    source: "legislationAssessment(type = Corporate)",
    domain: "watchlists",
    srvModule: "watchlists",
    priority: "nice",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["pie", "stacked-bar"],
    coveredByV1: false,
    xlsxRow: 79,
  },
])
